import { z } from 'zod';

export const OrganizationPropsSchema = z.object({
  external_id: z.string().optional(),
  name: z.string().min(1, 'Name is required'),
  website: z.string().optional(),
  organization_type: z.string().optional(),
  industry: z.string().optional(),
  geo: z
    .object({
      street: z.string().optional(),
      city: z.string().optional(),
      state: z.string().optional(),
      postal_code: z.string().optional(),
      country: z.string().optional(),
      latitude: z.number().optional(),
      longitude: z.number().optional(),
    })
    .optional(),
  status: z.string().optional(),
  source: z.string().optional(),
  source_raw_data_id: z.string().uuid().optional(),
  tenant_id: z.string().uuid().optional(),
});

export type OrganizationProps = z.infer<typeof OrganizationPropsSchema>;

export const ORGANIZATION_NATURAL_KEY_FIELD = 'website';
